export { default } from './AdvantagesItem';
